"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var boidFactory_1 = require("./boidFactory");
var boidAttractorFactory_1 = require("./boidAttractorFactory");
var p5_1 = require("p5");
exports.default = (function (width, height, depth, numBoids, boidsConfig) {
    if (width === void 0) { width = 100; }
    if (height === void 0) { height = 100; }
    if (depth === void 0) { depth = 10; }
    if (numBoids === void 0) { numBoids = 20; }
    if (boidsConfig === void 0) { boidsConfig = boidFactory_1.defaultConfig; }
    var _target = new p5_1.Vector();
    var _width = width;
    var _height = height;
    var _depth = depth;
    var startPos = [width / 2, height / 2, depth];
    var _boidConfig = __assign(__assign({}, boidFactory_1.defaultConfig), boidsConfig);
    var boids = [];
    /////------
    /////------
    /////------
    /////------
    /////------
    var attractors = [];
    for (var i = 0; i < numBoids; i++) {
        boids.push((0, boidFactory_1.create)(startPos, _boidConfig));
    }
    return {
        boids: boids,
        getPositions: function () {
            return boids.map(function (_a) {
                var getPosition = _a.getPosition;
                var _b = getPosition(), x = _b.x, y = _b.y, z = _b.z;
                var rotation = getPosition().heading();
                return { x: x, y: y, z: z, rotation: rotation };
            });
        },
        setTarget: function (value) {
            _target = value;
        },
        getTarget: function () {
            return _target;
        },
        setWidth: function (value) {
            _width = value;
        },
        getWidth: function () {
            return _width;
        },
        setHeight: function (value) {
            _height = value;
        },
        getHeight: function () {
            return _height;
        },
        setDepth: function (value) {
            _depth = value;
        },
        getDepth: function () {
            return _depth;
        },
        addAttractor: function (config) {
            var att = (0, boidAttractorFactory_1.create)(config);
            attractors.push(att);
            return att;
        },
        removeAttractor: function (value) {
            attractors = attractors.filter(function (d) { return d !== value; });
        },
        getAttractors: function () {
            return attractors;
        },
        //// -- BOUD GETTERS AND SETTERS 
        setBoidCohesionDistance: function (value) {
            boids.forEach(function (b) { return b.setCohesionDistance(value); });
        },
        getBoidCohesionDistance: function () {
            return boids[0].getCohesionDistance();
        },
        setBoidMaxSpeed: function (value) {
            boids.forEach(function (b) { return b.setMaxSpeed(value); });
        },
        getBoidMaxSpeed: function () {
            return boids[0].getMaxSpeed();
        },
        setBoidMaxForce: function (value) {
            boids.forEach(function (b) { return b.setMaxForce(value); });
        },
        getBoidMaxForce: function () {
            return boids[0].getMaxForce();
        },
        run: function () {
            boids.forEach(function (b) { return b.run(boids, { width: _width, height: _height, depth: _depth }); });
            attractors.forEach(function (a) { return a.run(boids); });
        }
    };
});
